<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18OpR0i/tc-custom/9781680573954.jpg?1740298000741" alt="This image is the cover for the book Aeronaut"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Aeronaut
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An American soldier in WWI France flies a jetpack over no man’s land in this steampunk historical adventure of action, espionage, and romance. </b></p><p> At the beginning of the twentieth century, Europe is in the grip of bitter and bloody war. Computational machinery has allowed great technological leaps on both sides—making trench warfare even deadlier for soldiers at the front. </p><p> Some men fight to defend their homeland. But Robert Preston flees America and joins the French Army to escape heartbreak. Placed in the elite 5th Aeronautic Corps, he learns to use high-tech jetpacks to leap over trenches—and the deadly no man’s land between them. It’s a dangerous job with a low survival rate, but Preston is determined to make a difference. </p><p> There, he meets a man he calls his best friend, and a woman he believes is the love of his life. But a top-secret mission behind enemy lines, and a heart full of jealousy, threatens to tear the three of them apart forever. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bryan Young
      </h2>
      
      <p class="authorDescription body article"> Bryan Young works across many different media. His work as a writer and producer has been called &quot;filmmaking gold&quot; by The New York Times. He&#39;s also published comic books with Slave Labor Graphics and Image Comics. He&#39;s been a regular contributor for the Huffington Post, StarWars.com, Star Wars Insider magazine, SYFY, /Film, and was the founder and editor in chief of the geek news and review site Big Shiny Robot! He co-authored Robotech: The Macross Saga RPG in 2019 and in 2020 he wrote a novel in the BattleTech Universe called Honor&#39;s Gauntlet. It won the League of Utah Writers&rsquo; Diamond Quill for 2021, reserved for the best book of the year written by a Utah Writer. Follow him on Twitter @swankmotron or visit www.swankmotron.com. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WordFire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7d9c7922